import { convertHexToRgbA } from '../utils';

const COLOR_SCHEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	LIGHT: 'light',
	DARK: 'dark',
	NEUTRAL: 'neutral',
	GHOST: 'ghost'
};

export const COLOR_SCHEME_STATES = {
	[COLOR_SCHEME.PRIMARY]: {
		normal: {
			backgroundColor: '#AA886A'
		},
		hover: {
			backgroundColor: '#A6876D'
		},
		active: {
			backgroundColor: '#927965'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.LIGHT]: {
		normal: {
			backgroundColor: '#ffffff'
		},
		hover: {
			backgroundColor: '#E5E5E5'
		},
		active: {
			backgroundColor: '#D9D9D9'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.DARK]: {
		normal: {
			backgroundColor: '#4F4A40'
		},
		hover: {
			backgroundColor: '#3E3A32'
		},
		active: {
			backgroundColor: '#312E29'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.NEUTRAL]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	},
	[COLOR_SCHEME.GHOST]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	}
};
